import { useContext, useEffect, useState } from "react";
import { tenantContext } from "../Main/contexts";
import {
    CreateMailbox,
    GetMailbox,
    GetMailboxEditorConfig,
    GetMailboxes,
    Mailbox,
    MailboxList,
    UpdateMailbox,
    UpdateMailboxEditorConfig,
} from "./TenantAPI";
import Loading from "../Generic/loading";
import DataTable, { dataColumn } from "../Generic/DataTable";
import { sortByField, SortEnquiriesParams } from "../Logic/sort";
import TextBox from "../Generic/TextBox";
import {
    lengthIsLessThan,
    lengthIsLessThanAndIsNotEmpty,
    numberIsBetween,
    numberIsLessThanMax,
} from "../Logic/validationRules";
import { GetUsers, UsersGridListDTO } from "../Users/TenantAPI";
import { Departments, GetDepartments } from "../Logic/department";
import { DerpartmentList } from "../Departments/TenantAPI";
import { GetSLATimeModels, SLATimeModel } from "../Logic/slaModles";
import Dropdown from "../Generic/DropDown";
import NumberBox from "../Generic/NumberBox";
import { GetConfig, GetConfigResponse, iMailboxConfig } from "../Logic/config";
import { GetMisModels, MisModel } from "../Logic/misModels";
import { PlusCircle } from "react-feather";
import ToggleSwitch from "../Generic/ToggleSwitch";
import TextArea from "../Generic/TextArea";

function Mailboxes() {
    const { selectedTenant } = useContext(tenantContext);
    const [mailboxes, setMailboxes] = useState<Array<MailboxList>>([]);
    const [mailboxesFiltered, setmailboxesFiltered] = useState<Array<MailboxList>>([]);
    const [allUsers, setAllUsers] = useState<Array<UsersGridListDTO>>([]);
    const [filteredUsers, setFiltertedUsers] = useState<Array<UsersGridListDTO>>([]);
    const [isLoading, setIsLoading] = useState<Boolean>(true);
    const [selectedItem, setSelectedItem] = useState("");
    const [sortBy, setSortBy] = useState<SortEnquiriesParams>();
    const [validationErrors, setValidationErrors] = useState<Array<string>>([]);
    const [selectedMailbox, setSelectedMailbox] = useState<Mailbox | undefined>(undefined);
    const [departments, setDepartments] = useState<Array<Departments>>([]);
    const [filtertedGridaData, setFiltertedGridaData] = useState<Array<DerpartmentList>>([]);
    const [allSLATimeModels, setAllSLATimeModels] = useState<Array<SLATimeModel>>([]);
    const [misModels, setMisModels] = useState<Array<MisModel>>([]);
    const [isNew, setIsNew] = useState<Boolean | undefined>(undefined);
    const [config, setConfig] = useState<GetConfigResponse | undefined>(undefined);
    const [editorConfig, setEditorConfig] = useState<iMailboxConfig | undefined>(undefined);
    useEffect(() => {
        (async () => {
            await loadData();
        })();
    }, [selectedTenant]);

    async function loadData() {
        if (selectedTenant) {
            const user_results = GetUsers(selectedTenant.token);
            const mailboxes_results = GetMailboxes(selectedTenant.token);
            const departments_results = GetDepartments(selectedTenant.token);
            const SLATimeModels_results = GetSLATimeModels(selectedTenant.token);
            const config_results = GetConfig(selectedTenant.token);
            const mis_results = GetMisModels(selectedTenant.token);
            Promise.all([
                user_results,
                mailboxes_results,
                departments_results,
                SLATimeModels_results,
                config_results,
                mis_results,
            ]).then(results => {
                if (results[0].isOk) {
                    let filtertedList = results[0].data!.users!.map(user => {
                        return {
                            id: user.id,
                            userName: user.firstname + " " + user.lastname,
                            blocked: user.blocked,
                            globalRole: user.globalRole,
                            department: user.department,
                        };
                    });
                    setAllUsers(filtertedList);
                    setFiltertedUsers(filtertedList);
                }
                if (results[1].isOk) {
                    setMailboxes(results[1].data?.items!);
                    setmailboxesFiltered(results[1].data?.items!);
                }
                if (results[2].isOk) {
                    setDepartments(results[2].data?.items!);
                    setFiltertedGridaData(results[2].data?.items!);
                }
                if (results[3].isOk) {
                    setAllSLATimeModels(results[3].data?.items!);
                }
                if (results[4].isOk) {
                    setConfig(results[4].data);
                }
                if (results[5].isOk && results[5].data) {
                    setMisModels(
                        results[5].data?.items!.sort((n1, n2) => {
                            if (n1.name > n2.name) {
                                return 1;
                            }

                            if (n1.name < n2.name) {
                                return -1;
                            }

                            return 0;
                        }),
                    );
                }

                setIsLoading(false);
            });
        }
    }
    let AllColumns: dataColumn<MailboxList>[] = [
        {
            title: <>Mailbox</>,
            toolTip: "name",
            key: "name",
            getData: (data: MailboxList) => {
                return <>{data.name}</>;
            },
            width: "100%",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    handleHeaderClick("name");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "60px",
        },
    ];
    const handleHeaderClick = (fieldName: string): any => {
        let sortO = sortBy;
        if (!sortO) {
            sortO = {
                orderBy: fieldName,
                desc: false,
            };
        } else {
            sortO.orderBy = fieldName;
            sortO.desc = sortO.desc ? false : true;
        }
        let updatedGrids = sortByField(mailboxesFiltered, fieldName, sortO.desc);
        setmailboxesFiltered(updatedGrids);
        setSortBy(sortO);
    };

    function OnFilter(filterValue: string) {
        let filtertedList = mailboxes;
        let filtered = filtertedList.filter(x => x.name.toLowerCase().includes(filterValue.toLowerCase()));
        setmailboxesFiltered(filtered);
    }

    const getMailboxInfo = async (val: string) => {
        setSelectedItem(val);
        const mailbox = GetMailbox(selectedTenant!.token, parseInt(val));
        const editorConfig = GetMailboxEditorConfig(selectedTenant!.token, parseInt(val));

        Promise.all([mailbox, editorConfig]).then(results => {
            if (results[0].isOk && results[0].data) {
                if (results[0].data.mailbox.productionTimes.length == 0) {
                    results[0].data.mailbox.productionTimes = [
                        { statusID: 3, productionTime: 0 },
                        { statusID: 4, productionTime: 0 },
                        { statusID: 5, productionTime: 0 },
                        { statusID: 6, productionTime: 0 },
                        { statusID: 8, productionTime: 0 },
                        { statusID: 9, productionTime: 0 },
                        { statusID: 10, productionTime: 0 },
                        { statusID: 11, productionTime: 0 },
                    ];
                }
                setSelectedMailbox(results[0].data.mailbox);
                setIsNew(false);
            }
            if (results[1].isOk && results[1].data) {
                setEditorConfig(results[1].data);
            } else if (!results[1].isOk) {
                setEditorConfig(undefined);
            }
        });
    };

    const updateValue = (field: string, value: any) => {
        let mMailbox = selectedMailbox ? JSON.parse(JSON.stringify(selectedMailbox)) : defaultMailbox;
        mMailbox[field] = value;
        setSelectedMailbox(mMailbox);
    };

    const updateMailboxConfigurationValue = (field: string, value: any) => {
        value = typeof value == "string" ? value : JSON.stringify(value);
        let mMailbox = selectedMailbox ? JSON.parse(JSON.stringify(selectedMailbox)) : defaultMailbox;
        mMailbox.mailboxConfiguration[field] = value;
        setSelectedMailbox(mMailbox);
    };

    const updateProductionTimeValue = (field: string, value: any) => {
        let mMailbox: Mailbox = selectedMailbox ? JSON.parse(JSON.stringify(selectedMailbox)) : defaultMailbox;
        let _productionTime = mMailbox.productionTimes.find(x => x.statusID.toString() == field);
        if (_productionTime) {
            _productionTime.productionTime = parseInt(value);
        }
        setSelectedMailbox(mMailbox);
    };

    let defaultMailbox = {
        id: 0,
        name: "",
        serviceCentreID: 0,
        managerID: 0,
        senderPrefix: "",
        emailAddress: "",
        pop3Server: "",
        pop3Port: 0,
        pop3Username: "",
        pop3Password: "",
        smtpServer: "",
        smtpPort: 1,
        enqRefPrefix: "",
        enqRefSuffix: "",
        slaTimeout: 1,
        slaReminder: 1,
        slaAlarm: 1,
        telephone: "",
        facsimile: "",
        boxEnabled: "F",
        slaTouchTimeout: 60,
        slaTouchReminder: 60,
        slaTouchAlarm: 60,
        flags: 1,
        priority: 0,
        popAfter: 1,
        popBefore: 1,
        misModelID: 0,
        autoResponse: "",
        everyEmail: "",
        responseExclusionMasks: "",
        responseTemplateID: null,
        boxSlaModelID: 0,
        userSlaModelID: 0,
        responseSlaModelID: 0,
        activeCycle: 0,
        productionTimes: [
            { statusID: 3, productionTime: 0 },
            { statusID: 4, productionTime: 0 },
            { statusID: 5, productionTime: 0 },
            { statusID: 6, productionTime: 0 },
            { statusID: 8, productionTime: 0 },
            { statusID: 9, productionTime: 0 },
            { statusID: 10, productionTime: 0 },
            { statusID: 11, productionTime: 0 },
        ],
        mailboxConfiguration: { pop3Settings: "", smtpSettings: "" },
    };
    function addMailbox() {
        setSelectedMailbox(defaultMailbox);
        setIsNew(true);
    }
    async function updateMailbox() {
        if (selectedTenant && selectedMailbox) {
            let result = await UpdateMailbox(selectedTenant.token, parseInt(selectedItem), selectedMailbox);
            if (!result.isOk && result.validationErrors) {
                alert(Object.values(result.validationErrors.errors));
                setIsNew(false);
            } else if (result.isOk) {
                if (editorConfig) {
                    result = await UpdateMailboxEditorConfig(
                        selectedTenant.token,
                        parseInt(selectedItem),
                        editorConfig,
                    );
                    if (!result.isOk && result.validationErrors) {
                        alert(Object.values(result.validationErrors.errors));
                        setIsNew(false);
                    } else if (result.isOk) {
                        setIsLoading(true);
                        alert("success");
                        await loadData();
                        setSelectedItem("");
                        setIsNew(undefined);
                    }
                } else {
                    setIsLoading(true);
                    alert("success");
                    await loadData();
                    setSelectedItem("");
                    setIsNew(undefined);
                }
            }
        }
    }
    async function createMailbox() {
        if (selectedTenant && selectedMailbox) {
            let result = await CreateMailbox(selectedTenant.token, selectedMailbox);
            if (!result.isOk && result.validationErrors) {
                alert(Object.values(result.validationErrors.errors));
                setIsNew(true);
            } else if (result.isOk) {
                setIsLoading(true);
                alert("success");
                await loadData();
                setSelectedItem("");
                setIsNew(undefined);
            }
        }
    }
    const defaultPop3Settings = () => {};
    return (
        <>
            <div className="topSection">
                <div className="sectionHeader">
                    {" "}
                    <PlusCircle
                        className="headerIcon"
                        onClick={addMailbox}
                    ></PlusCircle>
                    Mailbox{" "}
                </div>
                {selectedMailbox && isNew == false && (
                    <div>
                        <button
                            className="g-btn-large btn-primary"
                            onClick={updateMailbox}
                        >
                            {" "}
                            Update Mailbox{" "}
                        </button>
                    </div>
                )}
                {selectedMailbox && isNew == true && (
                    <div>
                        <button
                            className="g-btn-large btn-primary"
                            onClick={createMailbox}
                        >
                            {" "}
                            Create Mailbox{" "}
                        </button>
                    </div>
                )}
            </div>
            <div style={{ display: "flex", flexDirection: "row", height: "calc(100% - 51px)" }}>
                <div className="Users-bodyCol1">
                    {isLoading && <Loading></Loading>}
                    {!isLoading && (
                        <>
                            <div className="filterContainer">
                                <div>Filter: </div>
                                <div>
                                    <input
                                        type="text"
                                        style={{ width: "100%" }}
                                        onChange={e => OnFilter(e.currentTarget.value)}
                                        defaultValue={""}
                                    />
                                </div>
                            </div>
                            <DataTable
                                data={mailboxesFiltered}
                                columns={AllColumns}
                                onRowClick={(val: string) => {
                                    getMailboxInfo(val);
                                }}
                                onRowDblClick={() => {}}
                                selectedItem={selectedItem}
                                uniqueIdentifiyer={x => {
                                    return x.id.toString();
                                }}
                            ></DataTable>
                        </>
                    )}
                </div>
                {isNew != undefined && (
                    <div className="bodyCol2">
                        <div className="optionsRow">
                            <p style={{ marginBottom: "6px", marginTop: "-0px", fontWeight: "bold", fontSize: "12pt" }}>
                                Edit Mailbox{" "}
                            </p>
                        </div>
                        <div style={{ padding: "5px 0px 0px 5px" }}>
                            <b>General</b>
                            <div className="subHeaderWithLine">
                                <div className="subCol1">Name and Location &nbsp; </div>
                                <div className="subCol2">
                                    <hr />
                                </div>
                            </div>
                            <div className="customPaddingSubHeader">
                                <div className="formRow">
                                    <TextBox
                                        id={"name"}
                                        label="Mailbox Name"
                                        value={selectedMailbox?.name}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={50}
                                        requiredIdentifier={true}
                                        errorMessage={
                                            validationErrors.find(x => x == "name")
                                                ? "Field cannot be blank and must be less than 50 characters"
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThanAndIsNotEmpty}
                                    ></TextBox>
                                </div>
                                <div className="formRow">
                                    <Dropdown
                                        name="serviceCentreID"
                                        label="Department"
                                        value={
                                            selectedMailbox?.serviceCentreID == undefined
                                                ? ""
                                                : selectedMailbox.serviceCentreID.toString()
                                        }
                                        returnFunc={updateValue}
                                        Valid={true}
                                        options={[
                                            { label: "Please Select", value: "0" },
                                            ...departments.map(items => {
                                                return { label: items.name, value: items.id.toString() };
                                            }),
                                        ]}
                                    ></Dropdown>
                                </div>
                                <div className="formRow">
                                    <Dropdown
                                        name="managerID"
                                        label="Manager"
                                        value={
                                            selectedMailbox?.managerID == undefined
                                                ? ""
                                                : selectedMailbox.managerID.toString()
                                        }
                                        returnFunc={updateValue}
                                        Valid={true}
                                        options={[
                                            { label: "Please Select", value: "0" },
                                            ...allUsers.map(items => {
                                                return { label: items.userName, value: items.id.toString() };
                                            }),
                                        ]}
                                    ></Dropdown>
                                </div>
                                <div className="formRow">
                                    <ToggleSwitch
                                        name={"boxEnabled"}
                                        value={selectedMailbox?.boxEnabled == undefined ? "F" : "F"}
                                        checked={
                                            selectedMailbox?.boxEnabled == undefined
                                                ? false
                                                : selectedMailbox?.boxEnabled == "T"
                                                  ? true
                                                  : false
                                        }
                                        label={"Box Enabled"}
                                        returnFunc={(field: string, value: any) => {
                                            updateValue(field, value == true ? "T" : "F");
                                        }}
                                    ></ToggleSwitch>
                                </div>
                                {/* <div className="formRow">
                                    <NumberBox
                                        id={"flags"}
                                        label="Flags"
                                        value={selectedMailbox?.flags}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={
                                            validationErrors.find(x => x == "flags")
                                                ? "Value must be between  1 and 1440"
                                                : ""
                                        }
                                        validationFunc={numberIsBetween}
                                    ></NumberBox>
                                </div> */}
                            </div>
                            <div className="subHeaderWithLine">
                                <div className="subCol1">MIS Model &nbsp; </div>
                                <div className="subCol2">
                                    <hr />
                                </div>
                            </div>
                            <div className="customPaddingSubHeader">
                                <div className="formRow">
                                    <Dropdown
                                        name="misModelID"
                                        label="Mis Model"
                                        value={
                                            selectedMailbox?.misModelID == undefined
                                                ? ""
                                                : selectedMailbox.misModelID.toString()
                                        }
                                        returnFunc={updateValue}
                                        Valid={true}
                                        options={[
                                            { label: "None", value: "0" },
                                            ...misModels.map(items => {
                                                return {
                                                    label: items.name + " (" + items.id.toString() + ")",
                                                    value: items.id.toString(),
                                                };
                                            }),
                                        ]}
                                    ></Dropdown>
                                </div>
                            </div>
                            <div className="subHeaderWithLine">
                                <div className="subCol1">Mailbox Contact Settings &nbsp; </div>
                                <div className="subCol2">
                                    <hr />
                                </div>
                            </div>
                            <div className="customPaddingSubHeader">
                                <div className="formRow">
                                    <TextBox
                                        id={"senderPrefix"}
                                        label="Sender Name"
                                        value={selectedMailbox?.senderPrefix}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={50}
                                        requiredIdentifier={true}
                                        errorMessage={
                                            validationErrors.find(x => x == "serderPrefix")
                                                ? "Field cannot be blank and must be less than 50 characters"
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThanAndIsNotEmpty}
                                    ></TextBox>
                                </div>
                                <div className="formRow">
                                    <TextBox
                                        id={"emailAddress"}
                                        label="Sender Email"
                                        value={selectedMailbox?.emailAddress}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={50}
                                        requiredIdentifier={true}
                                        errorMessage={
                                            validationErrors.find(x => x == "emailAddress")
                                                ? "Field cannot be blank and must be less than 50 characters"
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThanAndIsNotEmpty}
                                    ></TextBox>
                                </div>

                                <div className="formRow">
                                    <TextBox
                                        id={"telephone"}
                                        label="Telephone"
                                        value={selectedMailbox?.telephone}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={30}
                                        errorMessage={
                                            validationErrors.find(x => x == "telephone")
                                                ? "Field must be less than 30 characters"
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThan}
                                    ></TextBox>
                                </div>

                                <div className="formRow">
                                    <TextBox
                                        id={"facsimile"}
                                        label="Facsimile"
                                        value={selectedMailbox?.facsimile}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={30}
                                        errorMessage={
                                            validationErrors.find(x => x == "facsimile")
                                                ? "Field must be less than 30 characters"
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThan}
                                    ></TextBox>
                                </div>
                            </div>
                            <div className="subHeaderWithLine">
                                <div className="subCol1">Enquiry Reference Naming Convention: &nbsp; </div>
                                <div className="subCol2">
                                    <hr />
                                </div>
                            </div>
                            <div className="customPaddingSubHeader">
                                <div className="formRow">
                                    <TextBox
                                        id={"enqRefPrefix"}
                                        label="Prefix"
                                        value={selectedMailbox?.enqRefPrefix}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={10}
                                        requiredIdentifier={true}
                                        errorMessage={
                                            validationErrors.find(x => x == "enqRefPrefix")
                                                ? "Field cannot be blank and must be less than 10 characters"
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThanAndIsNotEmpty}
                                    ></TextBox>
                                </div>

                                <div className="formRow">
                                    <TextBox
                                        id={"enqRefSuffix"}
                                        label="Suffix"
                                        value={selectedMailbox?.enqRefSuffix}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={10}
                                        requiredIdentifier={true}
                                        errorMessage={
                                            validationErrors.find(x => x == "enqRefSuffix")
                                                ? "Field cannot be blank and must be less than 10 characters"
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThanAndIsNotEmpty}
                                    ></TextBox>
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: "5px 0px 0px 5px" }}>
                            <div>
                                <b>Auto-Response</b>
                            </div>
                            <div className="subHeaderWithLine">
                                <div className="subCol1">Mailbox Auto-response Settings: &nbsp; </div>
                                <div className="subCol2">
                                    <hr />
                                </div>
                            </div>
                            <div className="customPaddingSubHeader">
                                <div className="formRow">
                                    <ToggleSwitch
                                        name={"autoResponse"}
                                        value={selectedMailbox?.autoResponse == undefined ? "F" : "F"}
                                        checked={
                                            selectedMailbox?.autoResponse == undefined
                                                ? false
                                                : selectedMailbox?.autoResponse == "T"
                                                  ? true
                                                  : false
                                        }
                                        label={"Enable Automatic Email Reponse"}
                                        returnFunc={(field: string, value: any) => {
                                            updateValue(field, value == true ? "T" : "F");
                                        }}
                                    ></ToggleSwitch>
                                </div>
                                <div className="textAreaRow">
                                    <TextArea
                                        id={"responseExclusionMasks"}
                                        label="Exclusion Mask List"
                                        value={selectedMailbox?.responseExclusionMasks}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        height="150px"
                                        maxLength={2400}
                                        errorMessage={
                                            validationErrors.find(x => x == "responseExclusionMasks")
                                                ? "Field cannot be blank and must be less than 50 characters"
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThanAndIsNotEmpty}
                                    ></TextArea>
                                </div>
                                <div className="formRow">
                                    <Dropdown
                                        name="responseTemplateID"
                                        label="Response Template"
                                        value={
                                            selectedMailbox?.responseTemplateID == undefined
                                                ? ""
                                                : selectedMailbox.responseTemplateID.toString()
                                        }
                                        returnFunc={updateValue}
                                        Valid={true}
                                        options={
                                            config == undefined
                                                ? []
                                                : config.templates.map(items => {
                                                      return { label: items.name, value: items.id.toString() };
                                                  })
                                        }
                                    ></Dropdown>
                                </div>

                                <div className="formRow">
                                    <p>
                                        By ticking the next option you will turn the autoresponse facility into an
                                        Out-Of-Office reply.
                                        <br /> Always ensure that the template selected is suitable for this type of
                                        response.
                                    </p>
                                    <ToggleSwitch
                                        name={"everyEmail"}
                                        value={selectedMailbox?.everyEmail == undefined ? "F" : "F"}
                                        checked={
                                            selectedMailbox?.everyEmail == undefined
                                                ? false
                                                : selectedMailbox?.everyEmail == "T"
                                                  ? true
                                                  : false
                                        }
                                        label={"Replay on every email received"}
                                        returnFunc={(field: string, value: any) => {
                                            updateValue(field, value == true ? "T" : "F");
                                        }}
                                    ></ToggleSwitch>
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: "5px 0px 0px 5px" }}>
                            <div>
                                <b>Cycles</b>
                            </div>
                            <div className="subHeaderWithLine">
                                <div className="subCol1">Enquiry SLA Cycle Configuration: &nbsp; </div>
                                <div className="subCol2">
                                    <hr />
                                </div>
                            </div>
                            <div className="customPaddingSubHeader">
                                <div className="formRow">
                                    <Dropdown
                                        name="boxSlaModelID"
                                        label="Box SLA Model "
                                        value={
                                            selectedMailbox?.boxSlaModelID == undefined
                                                ? ""
                                                : selectedMailbox.boxSlaModelID.toString()
                                        }
                                        returnFunc={updateValue}
                                        Valid={true}
                                        options={[
                                            { label: "Please Select", value: "0" },
                                            ...allSLATimeModels.map(items => {
                                                return { label: items.title, value: items.id.toString() };
                                            }),
                                        ]}
                                    ></Dropdown>
                                </div>

                                <div className="formRow">
                                    <Dropdown
                                        name="userSlaModelID"
                                        label="User SLA Model "
                                        value={
                                            selectedMailbox?.userSlaModelID == undefined
                                                ? ""
                                                : selectedMailbox.userSlaModelID.toString()
                                        }
                                        returnFunc={updateValue}
                                        Valid={true}
                                        options={[
                                            { label: "Please Select", value: "0" },
                                            ...allSLATimeModels.map(items => {
                                                return { label: items.title, value: items.id.toString() };
                                            }),
                                        ]}
                                    ></Dropdown>
                                </div>
                                <div className="formRow">
                                    <Dropdown
                                        name="responseSlaModelID"
                                        label="Response SLA Model "
                                        value={
                                            selectedMailbox?.responseSlaModelID == undefined
                                                ? ""
                                                : selectedMailbox.responseSlaModelID.toString()
                                        }
                                        returnFunc={updateValue}
                                        Valid={true}
                                        options={[
                                            { label: "Please Select", value: "0" },
                                            ...allSLATimeModels.map(items => {
                                                return { label: items.title, value: items.id.toString() };
                                            }),
                                        ]}
                                    ></Dropdown>
                                </div>
                                <div className="formRow">
                                    <Dropdown
                                        name="activeCycle"
                                        label="Active SLA Cycle"
                                        value={
                                            selectedMailbox?.activeCycle == undefined
                                                ? "Response"
                                                : selectedMailbox?.activeCycle.toString()
                                        }
                                        returnFunc={updateValue}
                                        Valid={true}
                                        options={[
                                            { label: "Box SLA Cycle", value: "Box" },
                                            { label: "Response SLA Cycle", value: "Response" },
                                        ]}
                                    ></Dropdown>
                                </div>
                            </div>
                            <div className="subHeaderWithLine">
                                <div className="subCol1">POP Rules: &nbsp; </div>
                                <div className="subCol2">
                                    <hr />
                                </div>
                            </div>
                            <div className="customPaddingSubHeader">
                                <div className="formRow">
                                    <NumberBox
                                        id={"popAfter"}
                                        label="Pop messages between"
                                        value={selectedMailbox?.popAfter}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={
                                            validationErrors.find(x => x == "popAfter")
                                                ? "Value must be between  0 and 1440"
                                                : ""
                                        }
                                        validationFunc={numberIsLessThanMax}
                                    ></NumberBox>
                                </div>
                                <div className="formRow">
                                    <NumberBox
                                        id={"popBefore"}
                                        label="and"
                                        value={selectedMailbox?.popBefore}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={
                                            validationErrors.find(x => x == "popBefore")
                                                ? "Value must be between  0 and 1440"
                                                : ""
                                        }
                                        validationFunc={numberIsLessThanMax}
                                    ></NumberBox>
                                </div>
                                <div className="formRow">
                                    <NumberBox
                                        id={"priority"}
                                        label="Default Priority for Enquiries"
                                        value={selectedMailbox?.priority}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={
                                            validationErrors.find(x => x == "priority")
                                                ? "Value must be between  0 and 1440"
                                                : ""
                                        }
                                        validationFunc={numberIsLessThanMax}
                                    ></NumberBox>
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: "5px 0px 0px 5px" }}>
                            <div>
                                <b>POP3 / SMTP</b>
                            </div>
                            <div className="subHeaderWithLine">
                                <div className="subCol1">POP Settings: &nbsp; </div>
                                <div className="subCol2">
                                    <hr />
                                </div>
                            </div>
                            <div className="customPaddingSubHeader">
                                <div className="formRow">
                                    <TextBox
                                        id={"pop3Server"}
                                        label="Server Name"
                                        value={selectedMailbox?.pop3Server}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={50}
                                        requiredIdentifier={true}
                                        errorMessage={
                                            validationErrors.find(x => x == "pop3Server")
                                                ? "Field cannot be blank and must be less than 50 characters"
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThanAndIsNotEmpty}
                                    ></TextBox>
                                </div>
                                <div className="formRow">
                                    <NumberBox
                                        id={"pop3Port"}
                                        label="Server Port"
                                        value={selectedMailbox?.pop3Port}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={
                                            validationErrors.find(x => x == "pop3Port")
                                                ? "Value must be between  1 and 1440"
                                                : ""
                                        }
                                        validationFunc={numberIsBetween}
                                    ></NumberBox>
                                </div>
                                <div className="formRow">
                                    <TextBox
                                        id={"pop3Username"}
                                        label="Username"
                                        value={selectedMailbox?.pop3Username}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={50}
                                        requiredIdentifier={true}
                                        errorMessage={
                                            validationErrors.find(x => x == "pop3Username")
                                                ? "Field cannot be blank and must be less than 50 characters"
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThanAndIsNotEmpty}
                                    ></TextBox>
                                </div>

                                <div className="formRow">
                                    <TextBox
                                        id={"pop3Password"}
                                        label="Password"
                                        value={selectedMailbox?.pop3Password}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={50}
                                        requiredIdentifier={true}
                                        errorMessage={
                                            validationErrors.find(x => x == "pop3Password")
                                                ? "Field cannot be blank and must be less than 50 characters"
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThanAndIsNotEmpty}
                                    ></TextBox>
                                </div>
                            </div>
                            <div className="subHeaderWithLine">
                                <div className="subCol1">SMTP Settings: &nbsp; </div>
                                <div className="subCol2">
                                    <hr />
                                </div>
                            </div>
                            <div className="customPaddingSubHeader">
                                <div className="formRow">
                                    <TextBox
                                        id={"smtpServer"}
                                        label="Server Name"
                                        value={selectedMailbox?.smtpServer}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={50}
                                        requiredIdentifier={true}
                                        errorMessage={
                                            validationErrors.find(x => x == "smtpServer")
                                                ? "Field cannot be blank and must be less than 50 characters"
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThanAndIsNotEmpty}
                                    ></TextBox>
                                </div>

                                <div className="formRow">
                                    <NumberBox
                                        id={"smtpPort"}
                                        label="Server Port"
                                        value={selectedMailbox?.smtpPort}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={
                                            validationErrors.find(x => x == "smtpPort")
                                                ? "Value must be between  1 and 1440"
                                                : ""
                                        }
                                        validationFunc={numberIsBetween}
                                    ></NumberBox>
                                </div>
                            </div>
                        </div>

                        {/*     <div style={{ padding: "5px 0px 0px 5px" }}>
                            <b>SLA</b>
                            <div className="subHeaderWithLine">
                                <div className="subCol1">SLA Options &nbsp; </div>
                                <div className="subCol2">
                                    <hr />
                                </div>
                            </div>

                            <div className="customPaddingSubHeader">
                                <div className="formRow">
                                    <NumberBox
                                        id={"slaTimeout"}
                                        label="SlaT imeout"
                                        value={selectedMailbox?.slaTimeout}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={
                                            validationErrors.find(x => x == "slaTimeout")
                                                ? "Value must be between  1 and 1440"
                                                : ""
                                        }
                                        validationFunc={numberIsBetween}
                                    ></NumberBox>
                                </div>

                                <div className="formRow">
                                    <NumberBox
                                        id={"slaReminder"}
                                        label="Sla Reminder"
                                        value={selectedMailbox?.slaReminder}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={
                                            validationErrors.find(x => x == "slaReminder")
                                                ? "Value must be between  1 and 1440"
                                                : ""
                                        }
                                        validationFunc={numberIsBetween}
                                    ></NumberBox>
                                </div>

                                <div className="formRow">
                                    <NumberBox
                                        id={"slaAlarm"}
                                        label="Sla Alarm"
                                        value={selectedMailbox?.slaAlarm}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={
                                            validationErrors.find(x => x == "slaAlarm")
                                                ? "Value must be between  1 and 1440"
                                                : ""
                                        }
                                        validationFunc={numberIsBetween}
                                    ></NumberBox>
                                </div>

                                <div className="formRow">
                                    <NumberBox
                                        id={"slaTouchTimeout"}
                                        label="SLA Touch Timeout"
                                        value={selectedMailbox?.slaTouchTimeout}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={
                                            validationErrors.find(x => x == "slaTouchTimeout")
                                                ? "Value must be between  1 and 1440"
                                                : ""
                                        }
                                        validationFunc={numberIsBetween}
                                    ></NumberBox>
                                </div>

                                <div className="formRow">
                                    <NumberBox
                                        id={"slaTouchReminder"}
                                        label="SLA Touch Reminder"
                                        value={selectedMailbox?.slaTouchReminder}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={
                                            validationErrors.find(x => x == "slaTouchReminder")
                                                ? "Value must be between  1 and 1440"
                                                : ""
                                        }
                                        validationFunc={numberIsBetween}
                                    ></NumberBox>
                                </div>

                                <div className="formRow">
                                    <NumberBox
                                        id={"slaTouchAlarm"}
                                        label="SLA Touch Alarm"
                                        value={selectedMailbox?.slaTouchAlarm}
                                        onChange={(field: string, value: any) => {
                                            updateValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={
                                            validationErrors.find(x => x == "slaTouchAlarm")
                                                ? "Value must be between  1 and 1440"
                                                : ""
                                        }
                                        validationFunc={numberIsBetween}
                                    ></NumberBox>
                                </div>
                            </div>
                        </div>*/}
                        <div style={{ padding: "5px 0px 0px 5px" }}>
                            <b>Production</b>
                            <div className="subHeaderWithLine">
                                <div className="subCol1">Production times &nbsp; </div>
                                <div className="subCol2">
                                    <hr />
                                </div>
                            </div>
                            <div className="customPaddingSubHeader">
                                <div style={{ padding: "10px 0px 12px 0px" }}>
                                    This section is used to record the time allocated to each exit status. The time is
                                    in seconds. These figures are then used to calculate how productive each user is
                                    over any period.
                                </div>
                                <div
                                    className="formRow"
                                    style={{ background: "#F3F3F3" }}
                                >
                                    <div
                                        className="textBoxContainer"
                                        key={"Main43"}
                                    >
                                        <div className="textBoxCol1">Enquiry Status</div>
                                        <div className="textBoxCol2">Time (sec)</div>
                                    </div>
                                </div>
                                <div className="formRow">
                                    <NumberBox
                                        id={"3"}
                                        label="Pending - General"
                                        value={
                                            selectedMailbox?.productionTimes.find(x => x.statusID == 3)?.productionTime
                                        }
                                        onChange={(field: string, value: any) => {
                                            updateProductionTimeValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={""}
                                        validationFunc={numberIsLessThanMax}
                                    ></NumberBox>
                                </div>
                                <div className="formRow">
                                    <NumberBox
                                        id={"4"}
                                        label="Pending - Request Internal Feedback"
                                        value={
                                            selectedMailbox?.productionTimes.find(x => x.statusID == 4)?.productionTime
                                        }
                                        onChange={(field: string, value: any) => {
                                            updateProductionTimeValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={""}
                                        validationFunc={numberIsLessThanMax}
                                    ></NumberBox>
                                </div>
                                <div className="formRow">
                                    <NumberBox
                                        id={"5"}
                                        label="Pending - Correspond with Enquirer"
                                        value={
                                            selectedMailbox?.productionTimes.find(x => x.statusID == 5)?.productionTime
                                        }
                                        onChange={(field: string, value: any) => {
                                            updateProductionTimeValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={""}
                                        validationFunc={numberIsLessThanMax}
                                    ></NumberBox>
                                </div>
                                <div className="formRow">
                                    <NumberBox
                                        id={"6"}
                                        label="Pending - Escalated"
                                        value={
                                            selectedMailbox?.productionTimes.find(x => x.statusID == 6)?.productionTime
                                        }
                                        onChange={(field: string, value: any) => {
                                            updateProductionTimeValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={""}
                                        validationFunc={numberIsLessThanMax}
                                    ></NumberBox>
                                </div>
                                <div className="formRow">
                                    <NumberBox
                                        id={"8"}
                                        label="Completed - Responded"
                                        value={
                                            selectedMailbox?.productionTimes.find(x => x.statusID == 8)?.productionTime
                                        }
                                        onChange={(field: string, value: any) => {
                                            updateProductionTimeValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={""}
                                        validationFunc={numberIsLessThanMax}
                                    ></NumberBox>
                                </div>
                                <div className="formRow">
                                    <NumberBox
                                        id={"9"}
                                        label="Completed - No Response"
                                        value={
                                            selectedMailbox?.productionTimes.find(x => x.statusID == 9)?.productionTime
                                        }
                                        onChange={(field: string, value: any) => {
                                            updateProductionTimeValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={""}
                                        validationFunc={numberIsLessThanMax}
                                    ></NumberBox>
                                </div>
                                <div className="formRow">
                                    <NumberBox
                                        id={"10"}
                                        label="Completed - Forwarded"
                                        value={
                                            selectedMailbox?.productionTimes.find(x => x.statusID == 10)?.productionTime
                                        }
                                        onChange={(field: string, value: any) => {
                                            updateProductionTimeValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={""}
                                        validationFunc={numberIsLessThanMax}
                                    ></NumberBox>
                                </div>
                                <div className="formRow">
                                    <NumberBox
                                        id={"11"}
                                        label="Completed - Reassigned"
                                        value={
                                            selectedMailbox?.productionTimes.find(x => x.statusID == 11)?.productionTime
                                        }
                                        onChange={(field: string, value: any) => {
                                            updateProductionTimeValue(field, value);
                                        }}
                                        maxLength={1440}
                                        errorMessage={""}
                                        validationFunc={numberIsLessThanMax}
                                    ></NumberBox>
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: "5px 0px 0px 5px" }}>
                            <b>Mailbox Configuration</b>
                            <div className="subHeaderWithLine">
                                <div className="subCol1">Additional settings &nbsp; </div>
                                <div className="subCol2">
                                    <hr />
                                </div>
                            </div>
                            <div className="customPaddingSubHeader">
                                <div style={{ padding: "10px 0px 12px 0px" }}>
                                    This section is used to record the additional configuration settings for the
                                    mailbox.
                                </div>
                                <div className="textAreaRow">
                                    <TextArea
                                        id={"pop3Settings"}
                                        label="POP3 Settings"
                                        value={selectedMailbox?.mailboxConfiguration?.pop3Settings ?? ""}
                                        onChange={(field: string, value: any) => {
                                            updateMailboxConfigurationValue(field, value);
                                        }}
                                        height="250px"
                                        maxLength={2400}
                                        errorMessage={
                                            validationErrors.find(x => x == "mailboxConfigurations.pop3Settings")
                                                ? "Field cannot be blank "
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThanAndIsNotEmpty}
                                    ></TextArea>
                                    <button
                                        style={{
                                            position: "relative",
                                            top: "-225px",
                                        }}
                                        className="g-btn btn-primary"
                                        onClick={() => {
                                            updateMailboxConfigurationValue(
                                                "pop3Settings",
                                                "{  \n  UserName: '', \n  FileNamePrefix: '',\n  Server: '',\n\  Port: 0, \n  AuthenticationMethods: '',\n  AuthenticationOptions: '',\n  MsalTenantId: '',\n  MsalClientId: '',\n  MsalClientSecret: '',\n  MsalScopes: ['https://outlook.office365.com/.default'],\n}",
                                            );
                                        }}
                                    >
                                        Default Settings
                                    </button>
                                </div>
                                <div className="textAreaRow">
                                    <TextArea
                                        id={"smtpSettings"}
                                        label="SMTP Settings"
                                        value={selectedMailbox?.mailboxConfiguration?.smtpSettings ?? ""}
                                        onChange={(field: string, value: any) => {
                                            updateMailboxConfigurationValue(field, value);
                                        }}
                                        height="250px"
                                        maxLength={2400}
                                        errorMessage={
                                            validationErrors.find(x => x == "mailboxConfigurations.smtpSettings")
                                                ? "Field cannot be blank "
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThanAndIsNotEmpty}
                                    ></TextArea>
                                    <button
                                        style={{
                                            position: "relative",
                                            top: "-225px",
                                        }}
                                        className="g-btn btn-primary"
                                        onClick={() => {
                                            updateMailboxConfigurationValue(
                                                "smtpSettings",
                                                '{ \n  "DatabaseID": "[DATABASEID]",  \n  "MailboxKey": [MAILBOXKEY], \n   "From": "[FROM]",  \n "Recipients": [ [RECIPIENTS] ],  \n  "Subject": "[SUBJECT]", \n   "Server": "smtp.office365.com",  \n     "Port": 587,  \n  "Priority": 0,\n   "Timeout": 60000,  \n  "Pipelining": true,  \n   "AuthenticationMethods": "Auto",  \n  "UserName": "",  \n     "Password": ""  \n  }',
                                            );
                                        }}
                                    >
                                        Default Settings
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div style={{ padding: "5px 0px 0px 5px" }}>
                            <b>Mailbox Editor Configuration</b>
                            <div className="subHeaderWithLine">
                                <div className="subCol1">Mailbox Editor Settings &nbsp; </div>
                                <div className="subCol2">
                                    <hr />
                                </div>
                            </div>
                            <div className="customPaddingSubHeader">
                                <div style={{ padding: "10px 0px 12px 0px" }}>
                                    This section is used to configure the mailbox editor settings. (things like default
                                    fonts and colors etc...)
                                </div>
                                <div className="textAreaRow">
                                    <TextArea
                                        id={"editorSettings"}
                                        label="Editor Settings"
                                        value={editorConfig ? JSON.stringify(editorConfig, null, 4) : ""}
                                        onChange={(field: string, value: any) => {
                                            setEditorConfig(JSON.parse(value));
                                        }}
                                        height="250px"
                                        maxLength={2400}
                                        errorMessage={
                                            validationErrors.find(x => x == "mailboxConfigurations.pop3Settings")
                                                ? "Field cannot be blank "
                                                : ""
                                        }
                                        validationFunc={lengthIsLessThanAndIsNotEmpty}
                                    ></TextArea>
                                    <button
                                        style={{
                                            position: "relative",
                                            top: "-225px",
                                        }}
                                        className="g-btn btn-primary"
                                        onClick={() => {
                                            setEditorConfig(
                                                JSON.parse(
                                                    '{"defaultFont":"CenturyGothic","defaultFontSize":"10px","availableFonts":["CenturyGothic","Aptos=\'Aptos\'"],"availableTextColors":[{"label":"HeritageGreen","hexCode":"#009677"},{"label":"FreshGreen","hexCode":"#50b848"},{"label":"FutureGreen","hexCode":"#8dc63f"},{"label":"Black","hexCode":"#000000"},{"label":"Red","hexCode":"#009677"},{"label":"Light Blue","hexCode":"#00C0E8"},{"label":"Yellow","hexCode":"#FFF200"},{"label":"Orange","hexCode":"#F37021"},{"label":"Cerise","hexCode":"#ED0080"}],"availableBackColors":[{"label":"HeritageGreen","hexCode":"#009677"},{"label":"FreshGreen","hexCode":"#50b848"},{"label":"FutureGreen","hexCode":"#8dc63f"},{"label":"Black","hexCode":"#000000"},{"label":"Red","hexCode":"#009677"},{"label":"Light Blue","hexCode":"#00C0E8"},{"label":"Yellow","hexCode":"#FFF200"},{"label":"Orange","hexCode":"#F37021"},{"label":"Cerise","hexCode":"#ED0080"}],"boldEnabled":true,"italicEnabled":true,"underlineEnabled":true,"bulletListEnabled":true,"numberListEnabled":true,"alignmentEnabled":true,"linkEnabled":true,"imageEnabled":true,"tableEnabled":true}',
                                                ),
                                            );
                                        }}
                                    >
                                        Default Settings
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
export default Mailboxes;
